"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, ChevronRight, Hash } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-muted/50 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group flex items-center text-muted-foreground hover:text-foreground transition-all duration-300 hover:translate-x-2 font-medium">
            <ChevronRight className="mr-1 h-4 w-4 opacity-0 -ml-5 transition-all duration-300 group-hover:opacity-100 group-hover:ml-0 text-primary" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 px-6 md:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://delicate-gnu.10web.cloud/wp-content/uploads/2026/04/GLENCROSS-CONSTRUCTION-2.png" alt="Glencross Construction Ltd Logo" className="w-auto object-contain !h-[80px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Delivering a full range of residential building services, from new-build homes to bespoke property developments with a strong focus on craftsmanship and reliability.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="48">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight">Contact Us</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-muted-foreground group">
                <MapPin className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm transition-colors group-hover:text-foreground">36 The Muntings, Stevenage, England, SG2 9DN</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground group">
                <Phone className="h-5 w-5 text-primary shrink-0" />
                <Link to="#" className="text-sm transition-colors group-hover:text-foreground">
                  +44 1234 567890
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground group">
                <Mail className="h-5 w-5 text-primary shrink-0" />
                <Link to="#" className="text-sm transition-colors group-hover:text-foreground">
                  info@glencrossconstruction.co.uk
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground group">
                <Hash className="h-5 w-5 text-primary shrink-0" />
                <span className="text-sm transition-colors group-hover:text-foreground">
                  Company No: 16734360
                </span>
              </li>
            </ul>
          </div>

          {}
          

        </div>

        <Separator className="bg-border/60 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© 2025&nbsp;Glencross Construction Ltd. All rights reserved.&nbsp; &nbsp; &nbsp; Company Number: 16734360</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}